import * as React from 'react';
import { useState } from 'react';
import { Alert, Button, Card } from "react-bootstrap";
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Unapproved() {
  const [error, setError] = useState("");
  const { logout, unapprovedMessage } = useAuth();
  const navigate = useNavigate();
  const [header, setHeader] = useState("");
  const [text, setText] = useState("");

  async function handleLogout() {
    setError("");
    try {
      await logout();
      navigate("/login");
    } catch {
      setError("Failed to log out");
    }
  }

  unapprovedMessage().then(unapprovedMessageValue => {
    console.log("Here")
    setHeader(unapprovedMessageValue[0]);
    setText(unapprovedMessageValue[1]);
  });

  return (
    <div>
      <Card>
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <h2 className='text-center mb-4'>{header}</h2>
          <div dangerouslySetInnerHTML={{__html: text}}></div>
          <div className="w-100 text-center mt-2">
            <Button onClick={handleLogout} className='btn-link m-auto'>Log Out</Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}
